import React from "react";
import Filters from "../components/form/Filters";

const RoleFilters = (props) => <Filters {...props} />;
export default RoleFilters;
